import { type CanActivateFn } from '@angular/router';
import { canActivateAuthGuard } from '@okta/okta-angular';

import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = (route, state) =>
  environment.authenticationRequired ? canActivateAuthGuard(route, state) : true;
